var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-teckensprok';
                    var viewUrl = 'gfx/sprite.svg#view-icon-teckensprok';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };